import React, { useState, useRef } from 'react';
import { Carousel, Modal } from 'antd';
import PropTypes from 'prop-types';
import { EyeOutlined } from '@ant-design/icons';
import { getImageUrl } from 'utils/tools';
import PreviewImage from '../PreviewImage';
import GridPhotosWrapper from './styles';

const GridPhotos = ({ images, width, height }) => {
  const carouselRef = useRef(null);
  const subImages = images ? [...images].splice(0, 0) : [];
  const [previewVisible, setPreviewVisible] = useState(null);

  const handleCancel = () => {
    setPreviewVisible(null);
  };

  const onPreviewUI = (index) => {
    setPreviewVisible(true);
    setTimeout(() => {
      carouselRef.current && carouselRef.current.goTo(index);
    }, 10);
  };
  return (
    <GridPhotosWrapper width={width} height={height}>
      {subImages.map((data, index) => (
        <PreviewImage
          onPreview={() => onPreviewUI(index)}
          key={String(index)}
          src={
            typeof data === 'string'
              ? getImageUrl(data)
              : getImageUrl(data && data.previewImage)
          }
        />
      ))}
      {images &&
      (images.length - subImages.length - 1 > 0 || images.length > 0) ? (
        <div className="imageCount">
          <img
            alt=""
            src={
              typeof images[0] === 'string'
                ? getImageUrl(images[0])
                : getImageUrl(images[0] && images[0].previewImage)
            }
            className="image"
          />
          <div className="overlay2">
            <EyeOutlined onClick={() => onPreviewUI(0)} />
          </div>
        </div>
      ) : null}

      <Modal visible={previewVisible} footer={null} onCancel={handleCancel}>
        <Carousel draggable ref={carouselRef}>
          {images &&
            images.map((data, index) => (
              <div key={String(index)}>
                <img
                  alt="example"
                  style={{ width: '100%', height: '100%' }}
                  src={
                    typeof data === 'string'
                      ? getImageUrl(data)
                      : getImageUrl(data && data.previewImage)
                  }
                />
              </div>
            ))}
        </Carousel>
      </Modal>
    </GridPhotosWrapper>
  );
};

GridPhotos.propTypes = {
  images: PropTypes.array,
  width: PropTypes.number,
  height: PropTypes.number,
};
GridPhotos.defaultProps = {
  images: [],
  width: 100,
  height: 100,
};

export default GridPhotos;
